<template>
  <a class="product-entry" @click="gotoProduct(product)" v-bind:class="{highlighted: highlighted}">
    <img :src="product.ImageUrl || config.defaultImage" />
    <div class="product-details">
        <div class="title-wrapper"><div class="product-title ellipsis maxlines-2">{{product.Product}}</div><div class="bookmark"><span>{{labels.topProduct}}</span></div></div>
        <div class="product-subtitle ellipsis maxlines-2">{{product.Subtitle}}</div>
        <p class="product-description ellipsis maxlines-3"><span v-html="product.Description"></span> &nbsp;</p>
        <a class="morelink textlink">{{labels.more}}</a>
    </div>
  </a>
</template>

<script>

import {DataLayer, Labels, Config} from "../services";

export default {
  name: "Product",
  props: {
    product : {
        type: Object
    },
    highlighted: {
        type: Boolean
    }
  },
  data (){
      return {
          labels: Labels,
          config: Config
      }
  },
  methods: {
      gotoProduct(product) {
          DataLayer.recordProduct(product);
          window.open(product.Url, "surfactants");
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .product-entry {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    cursor: pointer;
    padding: 20px 0;
  }

  .product-entry > img {
      width: 128px;
      min-width: 128px;
      height: 128px;
      border-top-left-radius:10px;
        border-bottom-left-radius:10px;
        border-top-right-radius:0px;
        border-bottom-right-radius:0px;
  }

  .product-entry > .product-details {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      width:100%;
  }

  .product-entry > .product-details > .title-wrapper {
      display: flex;
      align-items: center;
  }

  .product-entry > .product-details > .title-wrapper > .product-title {
      font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
      font-weight: 700;
      font-size: 18px;
      color: black;
  }
  .product-entry > .product-details > .product-subtitle {
      font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
      font-weight: 500;
      font-size: 16px;
      color: black;
      text-transform: uppercase
  }

  .product-entry > .product-details > .product-description {
      font-family: "Gotham Narrow", Arial, Helvetica, sans-serif;
      font-weight: 100;
      font-size: 15px;
      color: black;
  }

  .product-entry > .product-details > p {
      margin-bottom: 0px;
  }

  .product-entry > .product-details > .morelink {
      display: block;
      line-height: 15px;
      margin-top:5px;
      font-weight: 700;
  }

  .product-entry > .product-details > .title-wrapper > .bookmark {
      display: none;
  }

  /*.product-entry.highlighted > .product-details > .title-wrapper > .bookmark {
      display: block;
      color: white;
      background-color: #3394d9;
      background-image: linear-gradient(top,rgba(51,148,217,1) 50%,rgba(26,123,193,1) 100%);
      font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
      text-transform: uppercase;
      font-size: 11px;
      line-height: 11px;
      font-weight: 700;
      margin:-20px 0 0px 10px;
      padding:3px;
      box-sizing: border-box;
      position: relative;
  }

.product-entry.highlighted > .product-details > .title-wrapper > .bookmark > span:before {
    left: 0;
    border-width: 10px 0 0 10px;
}

  .product-entry.highlighted > .product-details > .title-wrapper > .bookmark > span:after {
    content: "";
    position: absolute;
    display: block;
    border-style: solid;
    border-color: #0062a6 transparent transparent transparent;
    bottom: -10px;
    right: 0;
    border-width: 10px 10px 0 0;
  }*/

  @media all and (max-width:600px) {
      /*.product-entry.highlighted > .product-details > .title-wrapper > .bookmark {
          font-size: 8px;
      }*/
      .product-entry {
            text-decoration: none;
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
            cursor: pointer;
            padding: 10px;
        }

        .product-entry > img {
            width: 64px;
            min-width: 64px;
            height: 64px;
            border-top-left-radius:10px;
            border-bottom-left-radius:10px;
            border-top-right-radius:0px;
            border-bottom-right-radius:0px;
        }
  }

</style>

